module.exports = __webpack_public_path__ + "img/pickleball.f63c1f42.svg";